var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-0 my-3 flex justify-center"},_vm._l((_vm.cardList),function(item){return _c('v-col',_vm._b({key:item.title,staticClass:"pa-0 mb-4"},'v-col',_vm.gridSettings,false),[_c('CardInfo',_vm._b({},'CardInfo',item,false))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }